import React from 'react';
import { Card } from './ui/card';
import { Button } from './ui/button';
import { Percent, CheckCircle, ArrowRight } from 'lucide-react';

export const TaxCredit = ({ t, onOpenContact }) => {
  return (
    <section className="py-16 bg-gradient-to-br from-[#D4AF37]/10 via-[#FFD700]/5 to-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 left-0 w-96 h-96 bg-[#D4AF37]/20 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 right-0 w-80 h-80 bg-yellow-200/30 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        <div className="max-w-5xl mx-auto">
          <Card className="bg-gradient-to-br from-white to-[#D4AF37]/5 border-[#D4AF37]/30 shadow-2xl overflow-hidden">
            <div className="grid lg:grid-cols-2 gap-0">
              {/* Left side - Eye-catching visual */}
              <div className="bg-gradient-to-br from-[#001f3f] to-[#003366] p-12 flex flex-col items-center justify-center text-center relative overflow-hidden">
                <div className="absolute inset-0 opacity-10">
                  <div className="absolute top-10 left-10 w-32 h-32 border-4 border-[#D4AF37] rounded-full"></div>
                  <div className="absolute bottom-10 right-10 w-40 h-40 border-4 border-[#D4AF37] rounded-full"></div>
                </div>
                
                <div className="relative z-10">
                  {/* Large percentage badge */}
                  <div className="inline-flex items-center justify-center w-40 h-40 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#FFD700] shadow-2xl shadow-[#D4AF37]/50 mb-6">
                    <div className="text-center">
                      <div className="text-6xl font-bold text-[#001f3f]">50</div>
                      <Percent className="w-12 h-12 text-[#001f3f] mx-auto -mt-2" />
                    </div>
                  </div>

                  <div className="text-[#D4AF37] text-2xl font-bold mb-2">
                    {t.taxCredit.badge}
                  </div>
                  <div className="text-slate-300 text-lg">
                    {t.taxCredit.subtitle}
                  </div>
                </div>
              </div>

              {/* Right side - Information */}
              <div className="p-12">
                <h3 className="text-3xl font-bold text-[#001f3f] mb-4">
                  {t.taxCredit.title}
                </h3>
                <p className="text-slate-600 text-lg leading-relaxed mb-6">
                  {t.taxCredit.description}
                </p>

                {/* Example calculation */}
                <div className="bg-gradient-to-r from-[#D4AF37]/10 to-[#FFD700]/10 rounded-xl p-6 mb-6 border border-[#D4AF37]/20">
                  <div className="flex items-center gap-2 mb-2">
                    <CheckCircle className="w-5 h-5 text-[#D4AF37]" />
                    <span className="font-semibold text-[#001f3f]">{t.taxCredit.example}</span>
                  </div>
                </div>

                {/* Benefits list */}
                <div className="space-y-3 mb-8">
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">
                      {t.language === 'fr' 
                        ? 'Toutes démarches administratives françaises' 
                        : 'All French administrative procedures'}
                    </span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">
                      {t.language === 'fr' 
                        ? 'Intervention à domicile ou à distance' 
                        : 'Home or remote intervention'}
                    </span>
                  </div>
                  <div className="flex items-start gap-3">
                    <CheckCircle className="w-5 h-5 text-[#D4AF37] flex-shrink-0 mt-0.5" />
                    <span className="text-slate-700">
                      {t.language === 'fr' 
                        ? 'Déclaration simplifiée pour votre crédit d\'impôt' 
                        : 'Simplified declaration for your tax credit'}
                    </span>
                  </div>
                </div>

                <Button 
                  onClick={onOpenContact}
                  className="bg-gradient-to-r from-[#D4AF37] to-[#FFD700] text-[#001f3f] hover:shadow-xl hover:shadow-[#D4AF37]/30 transition-all duration-300 font-semibold text-lg group"
                >
                  {t.taxCredit.cta}
                  <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
                </Button>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>
  );
};
